import {
  WEEKDAY_LABELS,
  addMonthsToMonthKey,
  buildMonthDayCells,
  formatDayLongRu,
  formatMonthLabelRu,
  monthKeyFromYmd,
  ymdInEkb,
} from './native-booking-presentation';

export function NativeMonthCalendar(props: {
  readonly selectedDate: string;
  readonly viewMonth: string;
  /** When false, day cells stay non-selectable (site/equipment not ready). Month nav still works. */
  readonly canSelectDays: boolean;
  readonly navigationDisabled?: boolean;
  readonly onViewMonthChange: (monthKey: string) => void;
  readonly onSelectDate: (ymd: string) => void;
}): React.ReactElement {
  const today = ymdInEkb(new Date());
  const cells = buildMonthDayCells(props.viewMonth);
  const monthLabel = formatMonthLabelRu(props.viewMonth);
  const navDisabled = props.navigationDisabled === true;

  return (
    <div className="native-cal" data-testid="native-month-calendar">
      <div className="native-cal-top">
        <div className="native-cal-nav">
          <button
            type="button"
            className="native-cal-icon-btn"
            aria-label="Предыдущий месяц"
            disabled={navDisabled}
            onClick={() => {
              props.onViewMonthChange(addMonthsToMonthKey(props.viewMonth, -1));
            }}
          >
            ‹
          </button>
          <h3 className="native-cal-label" id="native-cal-month-label">
            {monthLabel}
          </h3>
          <button
            type="button"
            className="native-cal-icon-btn"
            aria-label="Следующий месяц"
            disabled={navDisabled}
            onClick={() => {
              props.onViewMonthChange(addMonthsToMonthKey(props.viewMonth, 1));
            }}
          >
            ›
          </button>
        </div>
      </div>
      <div
        className="native-calendar"
        role="grid"
        aria-labelledby="native-cal-month-label"
      >
        <div className="native-week-head" role="row">
          {WEEKDAY_LABELS.map((label) => (
            <span key={label} role="columnheader">
              {label}
            </span>
          ))}
        </div>
        <div className="native-days" role="rowgroup">
          {cells.map((cell) => {
            const past = cell.ymd < today;
            const selected = cell.ymd === props.selectedDate;
            const disabled = !props.canSelectDays || past;
            const classNames = [
              'native-day',
              cell.inMonth ? '' : 'other',
              selected ? 'selected' : '',
              cell.ymd === today ? 'today' : '',
            ]
              .filter((x) => x !== '')
              .join(' ');
            return (
              <button
                key={cell.ymd}
                type="button"
                role="gridcell"
                className={classNames}
                data-day={cell.ymd}
                aria-label={formatDayLongRu(cell.ymd)}
                aria-pressed={selected}
                aria-disabled={disabled}
                disabled={disabled}
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  props.onSelectDate(cell.ymd);
                  if (monthKeyFromYmd(cell.ymd) !== props.viewMonth) {
                    props.onViewMonthChange(monthKeyFromYmd(cell.ymd));
                  }
                }}
              >
                {cell.dayNum}
                {!past && cell.inMonth ? <span className="native-day-dot" aria-hidden="true" /> : null}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
